export default "__VITE_ASSET__DhEapnRe__"